import { Component } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';

@Component({
    templateUrl: 'get-started.html',
    standalone: false
})

export class EmployerGetStartedMockPage {

  readonly desktopWidthContent: string = scrollContentWidth.LARGE;

  constructor(
    private navCtrl: CustomNavController
  ) {}

  goToPage(page) {
    this.navCtrl.navigateForward(page);
  }

}
